import { render, staticRenderFns } from "./Breadcrumbs2.vue?vue&type=template&id=e2fe5400&"
import script from "./Breadcrumbs2.vue?vue&type=script&lang=js&"
export * from "./Breadcrumbs2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports